import { useThemeContext } from '#contexts/ThemeContext';
import { useBreakpoints } from '#utils/breakpoint';
import { Box, Typography } from '@material-ui/core';

export const ProductName = ({ name }: { name: string }) => {
  const { productTitle } = useThemeContext();
  const { isLessThanSm } = useBreakpoints();

  return (
    <Box
      mt={{
        xs: 0,
        sm: 3
      }}
      mb={3}
      textAlign={isLessThanSm ? 'center' : 'left'}
    >
      <Typography
        variant='h6'
        className='semiBold'
        style={{
          color: productTitle
        }}
      >
        {name}
      </Typography>
    </Box>
  );
};
